import type { EscolhaNovoTipo } from "../novo-tipo-obra-dialog";
import type {
  CentroParaEscopo,
  AdicionarEscopoMacroDialogProps,
  TipoParaEscopo,
} from "./types-adicionar-escopo-macro-dialog";

export const PENDENTE_TIPO_VALOR = "pendente-novo-tipo";

type OpcoesNovoTipo = NonNullable<AdicionarEscopoMacroDialogProps["opcoesNovoTipo"]>;

export function rotuloCentro(principal: boolean, nome: string, codigo: string) {
  return `${principal ? "Centro de custo principal" : `Centro de custo ${nome}`} · ${codigo}`;
}

export function centrosComPendente(
  centros: CentroParaEscopo[],
  pendente: EscolhaNovoTipo | null,
): CentroParaEscopo[] {
  if (!pendente) return centros;
  const tipo: TipoParaEscopo = {
    obraTipoObraId: PENDENTE_TIPO_VALOR,
    tipoObraId: pendente.tipo.id,
    codigo: pendente.tipo.codigo,
    rotulo: pendente.tipo.rotulo,
    cancelamentoPendente: false,
    fonteEscopo: pendente.tipo.fonteEscopo,
    escoposIncluidos: [],
    pendente: true,
  };
  if (centros.some((centro) => centro.id === pendente.centroCusto.id))
    return centros.map((centro) =>
      centro.id === pendente.centroCusto.id
        ? { ...centro, tipos: [...centro.tipos, tipo] }
        : centro,
    );
  return [
    ...centros,
    {
      id: pendente.centroCusto.id,
      rotulo: pendente.centroCusto.rotulo,
      principal: pendente.centroCusto.principal,
      tipos: [tipo],
      pendente: true,
    },
  ];
}

function comTipoElegivel(opcoes: OpcoesNovoTipo, manter: (id: string) => boolean): OpcoesNovoTipo {
  const dados = opcoes.data;
  if (!dados) return opcoes;
  return {
    ...opcoes,
    data: {
      ...dados,
      centrosCusto: dados.centrosCusto.filter(
        (centro) =>
          manter(centro.id) &&
          centro.elegivel &&
          centro.tiposObraElegiveis.some((tipo) => tipo.bloqueio === null),
      ),
    },
  };
}

export const opcoesDeCentroNovo = (opcoes: OpcoesNovoTipo, idsDaObra: string[]) =>
  comTipoElegivel(opcoes, (id) => !idsDaObra.includes(id));

export const opcoesDoCentro = (opcoes: OpcoesNovoTipo, centroId: string) =>
  comTipoElegivel(opcoes, (id) => id === centroId);
